import { render, staticRenderFns } from "./Vitals.vue?vue&type=template&id=ea750c32&"
import script from "./Vitals.vue?vue&type=script&lang=js&"
export * from "./Vitals.vue?vue&type=script&lang=js&"
import style0 from "./Vitals.vue?vue&type=style&index=0&id=ea750c32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports